import VueRouter, { RawLocation, Route } from 'vue-router'

let pendingRedirect: Promise<Route> | null = null

function isSameRoute (router: VueRouter, location: RawLocation): boolean {
    if (typeof location === 'string') {
        return router.currentRoute.path === location || router.currentRoute.fullPath === location
    }

    if (location.name) {
        return router.currentRoute.name === location.name
    }

    if (location.path) {
        return router.currentRoute.path === location.path
    }

    return false
}

export function hasPendingRedirect (): boolean {
    return pendingRedirect !== null
}

export function redirectToRouteOnce (router: VueRouter, location: RawLocation): Promise<Route> {
    if (pendingRedirect) {
        return pendingRedirect
    }

    if (isSameRoute(router, location)) {
        return Promise.resolve(router.currentRoute)
    }

    pendingRedirect = router.push(location).finally(() => {
        pendingRedirect = null
    })

    return pendingRedirect
}
